import type { FechamentoItem } from "../../../services/historicoFechamentos"

export enum HistoricoFechamentosActionsTypes {
    CARREGAR = "CARREGAR",
}

export type HistoricoFechamentosActions = {
    type: HistoricoFechamentosActionsTypes.CARREGAR
    payload: FechamentoItem[]
}
